export { Tabs, type TabsProps, type TabsType } from './Tabs';
